import item1 from './Images/Items/item1.jpg';
import item2 from './Images/Items/item2.jpg';
import item3 from './Images/Items/item3.jpg';
import item4 from './Images/Items/item4.jpg';
import item5 from './Images/Items/item5.jpg';
import item6 from './Images/Items/item6.jpg';
import item7 from './Images/Items/item7.jpg';
import item8 from './Images/Items/item8.jpg';
import item9 from './Images/Items/item9.jpg';
import item10 from './Images/Items/item10.jpg';
import item11 from './Images/Items/item11.jpg';
import item12 from './Images/Items/item12.jpg';


export const items = [
    {
        id: 1,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item1,
        price: 799,
        quantity: 0
    },
    {
        id: 2,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item2,
        price: 799,
        quantity: 0
    },
    {
        id: 3,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item3,
        price: 799,
        quantity: 0
    },
    {
        id: 4,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item4,
        price: 799,
        quantity: 0
    },
    {
        id: 5,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item5,
        price: 799,
        quantity: 0
    },
    {
        id: 6,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item6,
        price: 799,
        quantity: 0
    },
    {
        id: 7,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item7,
        price: 799,
        quantity: 0
    },
    {
        id: 8,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item8,
        price: 799,
        quantity: 0
    },
    {
        id: 9,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item9,
        price: 799,
        quantity: 0
    },
    {
        id: 10,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item10,
        price: 799,
        quantity: 0
    },
    {
        id: 11,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item11,
        price: 799,
        quantity: 0
    },
    {
        id: 12,
        dec: "Men's Tshirt",
        name: "Sevelian Oversized Tee",
        image: item12,
        price: 799,
        quantity: 0
    },
]